import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import RetroProgress from '@/components/progress/RetroProgress.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Footer',
    setup(__props) {
        const retroStore = useRetroStore();
        const { phase, isLoaded } = storeToRefs(retroStore);
        return (_ctx, _cache) => {
            return (_unref(isLoaded) && _unref(phase) !== 'finished')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(RetroProgress)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
